import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=4821ea96&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=4821ea96&prod&lang=scss&scoped=true&"
import style1 from "./Slider.vue?vue&type=style&index=1&id=4821ea96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821ea96",
  null
  
)

export default component.exports